import React from 'react';
import PropTypes from "prop-types";
import {Form} from "react-bootstrap";

function Phone(props) {
    const prefix = ['0402', '0404', '0504', '0505', '01', '071', '074', '083', '085', '086', '087', '089', '090']
    const array = ['2', '4', '5', '6', '9']
    array.forEach(secondDigit => {
        let i = 1
        while (i < 10) {
            let newPfx = `0${secondDigit}${i}`
            if (!['092', '054', '055'].includes(newPfx)) {
                prefix.push(newPfx)
            }
            i += 1
        }
    })

    props.elementProps.onKeyPress = function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            return e.target.blur()
        }
        if (e.key === 'Backspace' || e.keyCode === 8) {
            return
        }

        const charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
        const charStr = String.fromCharCode(charCode);
        const digit = (/\d/.test(charStr) || ['(', ')', '-'].includes(charStr))
        if (!digit) return

        // if the cursor is at the end of the field, format to a date like string
        if (e.target.value.length === e.target.selectionStart && e.target.selectionEnd - e.target.selectionStart === 0) {
            let orig = e.target.value
            const charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
            const charStr = String.fromCharCode(charCode);
            let temp = orig + '' + charStr
            if (temp === '00'){
                e.preventDefault()
                e.target.value = "+"
                return
            }
            if (prefix.includes(temp)) {
                e.preventDefault()
                temp = `(${temp}) `
                e.target.value = temp
                return
            }

            const dashLen = temp.includes('(01)') ? 8 : 9
            const l = temp.split('')
            if (l.includes('(') && l.includes(')') && l.length === dashLen) {
                e.preventDefault()
                e.target.value = `${temp}-`
                return
            }
        }
    }
    props.elementProps.onBlur = function (e) {
        const regExp = /\(([^)]+)\)/;
        const matches = regExp.exec(e.target.value);
        let val = e.target.value.replace('(', '').replace(')', '')
        if (matches && matches.length > 1 && prefix.includes(matches[1])){
            val = "+353 " + val.trim().substring(1)
        }
        else{
            if (val.trim().length > 7 && val.trim().charAt(0) !== "+"){
                val = "+" + val
            }
        }
        //val = val.replace(/[^0-9+]/g, '')
        props.setAnswer(val)
    }
    return (<Form.Control type="tel" {...props.elementProps} />)
}
Phone.propTypes = {
    defaultValue: PropTypes.string,
    setAnswer: PropTypes.func,
    onFocus: PropTypes.func,
    rightElement: PropTypes.element,
    clean: PropTypes.func,
    format: PropTypes.string
};
export default Phone;